<template>
  <!-- 招租条件 -->
  <section id="qualification" class="anchor-section">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">
          招租条件与承租方资格条件
        </div>
      </a-space>
    </div>

    <a-descriptions bordered :column="1" class="desc-block">
      <template slot="title">
        <div class="desc-title">招租条件</div>
      </template>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">租赁期限</span>
        </template>
        {{ bidBaseInfo.leaseTerm
        }}{{ bidBaseInfo.leaseTermUnit == 1 ? "个月" : "年" }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">出租价格</span>
        </template>
        <div>
          出租底价：{{ bidBaseInfo.floorPrice
          }}{{
            bidBaseInfo.floorPriceUnit == 1
              ? "元/月"
              : bidBaseInfo.floorPriceUnit == 2
              ? "元/年"
              : ""
          }}
        </div>
        <div>
          备注：若以年租金为出租底价，该价格不含免租期，一年按365日计，月租金按照年租金除以12计算
        </div>
      </a-descriptions-item>

      <!-- todo -->
      <!-- <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">参考租金单价</span>
        </template>

        <div>2.50 元/平/天</div>
        <div>
          租金参考价：本信息仅供参考，不构成出租方或平台对出租标的的任何要约、承诺或保证。本项目招租底价以招租公告信息为准。
        </div>
      </a-descriptions-item> -->

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">租赁面积（平方米）</span>
        </template>
        {{ houseBaseInfo.leaseArea }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">租金调整方式</span>
        </template>
        {{
          bidBaseInfo.hasRentAdjustments == 1
            ? bidBaseInfo.rentAdjustmentWay || ""
            : "无"
        }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">免租期</span>
        </template>
        {{
          bidBaseInfo.hasRentFreePeriod == 1
            ? "有：免租期时间" +
              (bidBaseInfo.rentFreePeriod || "") +
              (bidBaseInfo.rentFreePeriodUnit == 1
                ? "日"
                : bidBaseInfo.rentFreePeriodUnit == 2
                ? "个月"
                : "") +
              "；" +
              (bidBaseInfo.isRfpEtLr == 1
                ? "优先承租权人续租享有免租期"
                : "优先承租权人续租不享有免租期") +
              "；" +
              (bidBaseInfo.hasRentContainFreePeriod == 1
                ? "租赁期限包含免租期"
                : "租赁期限不包含免租期")
            : "无"
        }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">租赁类型</span>
        </template>
        {{
          Array.isArray(bidBaseInfo.leaseType)
            ? bidBaseInfo.leaseType
                .map((v) => (v == 1 ? "房屋" : v == 2 ? "场地" : ""))
                .filter(Boolean)
                .join("、")
            : bidBaseInfo.leaseType == 1
            ? "房屋"
            : bidBaseInfo.leaseType == 2
            ? "场地"
            : ""
        }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">租赁用途</span>
        </template>
        <div>
          {{
            Array.isArray(houseBaseInfo.leaseUseType)
              ? houseBaseInfo.leaseUseType
                  .map((v) =>
                    v == 1
                      ? "商业"
                      : v == 2
                      ? "楼宇办公"
                      : v == 8
                      ? "园区"
                      : v == 16
                      ? "仓储"
                      : v == 32
                      ? "厂房"
                      : v == 64
                      ? "酒店"
                      : v == 256
                      ? "住宅"
                      : v == 512
                      ? "公寓"
                      : v == 1024
                      ? "工业"
                      : v == 2048
                      ? "农用"
                      : v == 4096
                      ? "市政配套"
                      : v == 8192
                      ? "场地"
                      : v == 16384
                      ? "其他"
                      : ""
                  )
                  .filter(Boolean)
                  .join("、")
              : ""
          }}
        </div>
        <div>
          风险提示：证载用途与租赁用途不一致，承租方承租后如需办理营业执照等事项，相应风险需自行承担
        </div>
      </a-descriptions-item>

      <a-descriptions-item
        v-if="
          Array.isArray(houseBaseInfo.leaseUseType) &&
          (houseBaseInfo.leaseUseType.includes(1) ||
            houseBaseInfo.leaseUseType.includes(8))
        "
      >
        <template slot="label">
          <span class="desc-label-text">业态要求</span>
        </template>
        <div>
          商业细分业态：{{ bidBaseInfo.businessCategories
          }}{{ bidBaseInfo.parkCategories }}
        </div>
        <div>
          {{ bidBaseInfo.formatRequirements }}
        </div>
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">装修现状</span>
        </template>
        {{
          bidBaseInfo.currentSituationDecoration == 1
            ? "精装"
            : bidBaseInfo.currentSituationDecoration == 2
            ? "毛坯"
            : bidBaseInfo.currentSituationDecoration == 3
            ? "简装"
            : bidBaseInfo.currentSituationDecoration == 4
            ? "拎包入住"
            : ""
        }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">是否允许装修改造</span>
        </template>
        {{ bidBaseInfo.allowRemodeling == 1 ? "是" : "否" }}
      </a-descriptions-item>

      <a-descriptions-item v-if="bidBaseInfo.allowRemodeling == 1">
        <template slot="label">
          <span class="desc-label-text">装修改造说明</span>
        </template>
        {{ bidBaseInfo.remodelingDesc }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">是否有停车位</span>
        </template>
        {{
          bidBaseInfo.parkingSpaceAvailable == 1
            ? bidBaseInfo.numberParkingSpaces
              ? bidBaseInfo.numberParkingSpaces + "个"
              : ""
            : "无"
        }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">是否可转租</span>
        </template>
        {{
          bidBaseInfo.sublease == 1
            ? "可转租" +
              (bidBaseInfo.subleaseDesc ? "：" + bidBaseInfo.subleaseDesc : "")
            : "不可转租"
        }}
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions bordered :column="1" class="desc-block">
      <template slot="title">
        <div class="desc-title">承租方需承担的其他费用</div>
      </template>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">物业管理费</span>
        </template>
        {{
          bidBaseInfo.hasPropertyManagementFee == 1
            ? "有物业管理费用，" +
              (bidBaseInfo.propertyManagementFeeWay == 1
                ? "由承租方直接与物业结算"
                : bidBaseInfo.propertyManagementFeeWay == 2
                ? "其他-" + (bidBaseInfo.propertyManagementFeeWayDesc || "")
                : "") +
              "，物业管理费用金额：" +
              (bidBaseInfo.propertyManagementFee || "") +
              (bidBaseInfo.propertyManagementFeeUnit == 1
                ? "元/天/平方米"
                : bidBaseInfo.propertyManagementFeeUnit == 2
                ? "元/月/平方米"
                : "")
            : "无物业管理费用"
        }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">水电气热等费用</span>
        </template>
        {{
          bidBaseInfo.utilityFee == 1
            ? "承租方直接支付"
            : bidBaseInfo.utilityFee == 2
            ? "其他" +
              (bidBaseInfo.utilityFeeDesc
                ? "：" + bidBaseInfo.utilityFeeDesc
                : "")
            : ""
        }}
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions bordered :column="1" class="desc-block">
      <template slot="title">
        <div class="desc-title">押金及租金支付要求</div>
      </template>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">是否支付押金</span>
        </template>
        {{
          bidBaseInfo.hasPayDeposit === 1
            ? "是"
            : bidBaseInfo.hasPayDeposit === 0
            ? "否"
            : "--"
        }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">押金交纳要求</span>
        </template>
        {{ bidBaseInfo.depositPayRequirement }}
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">租金支付要求</span>
        </template>
        <template v-if="bidBaseInfo.rentPaymenclaim === 1"> 按月 </template>
        <template v-else-if="bidBaseInfo.rentPaymenclaim === 2">
          按季度
        </template>
        <template v-else-if="bidBaseInfo.rentPaymenclaim === 3">
          按年
        </template>
        <template v-else-if="bidBaseInfo.rentPaymenclaim === 4">
          其他<span v-if="bidBaseInfo.rentPaymenclaimDesc">
            ：{{ bidBaseInfo.rentPaymenclaimDesc }}
          </span>
        </template>
        <template v-else> - </template>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions bordered :column="1" class="desc-block">
      <template slot="title">
        <div class="desc-title">其他说明事项</div>
      </template>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">事项说明</span>
        </template>
        <div>
          本标的房屋系按间或按栋对外招租，不按权证面积计算。若该房屋的建筑面积经任何测量机构测量存在差异的，不影响本次招租确定的租金的价格。
        </div>
        <div>
          是否存在以上情形：<template v-if="bidBaseInfo.hasExistAbove === 1">
            是
          </template>
          <template v-else-if="bidBaseInfo.hasExistAbove === 0"> 否 </template>
          <template v-else> - </template>
        </div>
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">抵押情况</span>
        </template>
        <template v-if="bidBaseInfo.mortgage === 1"> 存在 </template>
        <template v-else-if="bidBaseInfo.mortgage === 0"> 不存在 </template>
        <template v-else> - </template>
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">是否存在优先承租权人</span>
        </template>
        <template v-if="bidBaseInfo.hasPriorityLease === 1"> 是 </template>
        <template v-else-if="bidBaseInfo.hasPriorityLease === 0"> 否 </template>
        <template v-else> - </template>
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">房屋状态</span>
        </template>
        <template v-if="houseBaseInfo.houseStatus === '1'">
          本标的房屋租赁合同已到期，房屋尚在使用中，若招租后发生移交纠纷，由出租方负责解决
        </template>

        <template v-else-if="houseBaseInfo.houseStatus === '2'">
          本标的房屋尚在租赁合同期内，到期后由出租方负责落实资产交付相关事项
        </template>

        <template v-else-if="houseBaseInfo.houseStatus === '3'">
          本标的房屋物业状态为空置
        </template>

        <template v-else-if="houseBaseInfo.houseStatus === '99'">
          其他
          <span v-if="houseBaseInfo.housingStatusOtherDesc">
            ：{{ houseBaseInfo.housingStatusOtherDesc }}
          </span>
        </template>

        <template v-else> - </template>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions bordered :column="1" class="desc-block">
      <template slot="title">
        <div class="desc-title">其他招租条件</div>
      </template>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">其他招租条件</span>
        </template>
        <div>
          {{ bidBaseInfo.otherRequirement }}
        </div>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions bordered :column="1" class="desc-block">
      <template slot="title">
        <div class="desc-title">承租资格条件</div>
      </template>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">意向承租方范围</span>
        </template>
        <div>
          <template v-if="getIntentionLeaseRangeText()">
            {{ getIntentionLeaseRangeText() }}
          </template>
          <template v-else> - </template>
        </div>
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">承租资格条件</span>
        </template>
        <div>{{ bidBaseInfo.qualificationCondition }}</div>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions bordered :column="1" class="desc-block">
      <template slot="title">
        <div class="desc-title">招租流程</div>
      </template>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">招租流程</span>
        </template>
        <div>1、 意向承租方租赁流程</div>
        <div>1.1参与报名</div>
        <div>
          意向承租方应在项目公告期内至本网站注册并实名认证，登录账号后进入“我要报名”，填写“意向承租申请”并上传相应材料；同时，按照公告要求在本项目招租公告发布期满前交纳保证金至租赁平台指定账户。（若本项目不设置保证金，则不涉及）意向承租方递交承租申请但逾期未交纳保证金的，视为放弃申请意向承租资格。
        </div>
        <div>1.2参与租赁活动</div>
        <div>
          信息发布期满后，意向承租方按以下方式确定最终承租方及承租价格：
        </div>
        <div class="bid-mode-template">
          <!-- 第一行 -->
          <div class="bid-mode-row">
            <span
              >{{ bidBaseInfo.transactionModeType === 1 ? "☑" : "☐" }}竞价</span
            >

            <span>
              {{
                bidBaseInfo.transactionModeType === 1 &&
                bidBaseInfo.transactionMode === 1 &&
                bidBaseInfo.onlineBiddingMode === 2
                  ? "☑"
                  : "☐"
              }}网络竞价-一次报价

              <!-- 只在选中一次报价时显示 -->
              <template
                v-if="
                  bidBaseInfo.transactionModeType === 1 &&
                  bidBaseInfo.transactionMode === 1 &&
                  bidBaseInfo.onlineBiddingMode === 2
                "
              >
                （{{ bidBaseInfo.hasPriorityLease === 1 ? "☑" : "☐" }}有优先权
                {{ bidBaseInfo.hasPriorityLease === 0 ? "☑" : "☐" }}无优先权）
              </template>
            </span>
          </div>

          <!-- 第二行（多次报价） -->
          <div class="bid-mode-row sub-row">
            <span></span>

            <span>
              {{
                bidBaseInfo.transactionModeType === 1 &&
                bidBaseInfo.transactionMode === 1 &&
                bidBaseInfo.onlineBiddingMode === 1
                  ? "☑"
                  : "☐"
              }}网络竞价-多次报价

              <!-- 只在选中多次报价时显示 -->
              <template
                v-if="
                  bidBaseInfo.transactionModeType === 1 &&
                  bidBaseInfo.transactionMode === 1 &&
                  bidBaseInfo.onlineBiddingMode === 1
                "
              >
                （{{ bidBaseInfo.hasPriorityLease === 1 ? "☑" : "☐" }}有优先权
                {{ bidBaseInfo.hasPriorityLease === 0 ? "☑" : "☐" }}无优先权）
              </template>
            </span>
          </div>

          <!-- 空一行（视觉分组） -->
          <div class="gap-row"></div>

          <!-- 第二组 -->
          <div class="bid-mode-row">
            <span
              >{{
                bidBaseInfo.transactionModeType === 2 ? "☑" : "☐"
              }}择优遴选</span
            >
            <span
              >{{ bidBaseInfo.transactionMode === 2 ? "☑" : "☐" }}权重报价</span
            >
          </div>

          <div class="bid-mode-row sub-row">
            <span></span>
            <span
              >{{
                bidBaseInfo.transactionMode === 7 ? "☑" : "☐"
              }}竞争性谈判</span
            >
          </div>

          <!-- 空一行 -->
          <div class="gap-row"></div>

          <!-- 第三组 -->
          <div class="bid-mode-row">
            <span>
              {{ bidBaseInfo.transactionModeType === 3 ? "☑" : "☐" }}其他竞价
              <template
                v-if="
                  bidBaseInfo.transactionModeType === 3 &&
                  bidBaseInfo.otherBidDesc
                "
              >
                ：{{ bidBaseInfo.otherBidDesc }}
              </template>
            </span>
          </div>
        </div>
        <div>
          本项目采取多次报价方式确定承租方。所有意向承租方应按照租赁平台的通知要求在规定时限内通过租赁平台的网络竞价系统进行报价，高于或等于公告条件（含出租底价）的最高报价成为承租价格。
        </div>
        <div>意向承租方参与竞价前需详细了解并确认竞价方案须知的内容。</div>
        2、出租方是否审查意向方资格：
        <template v-if="bidBaseInfo.hasQualificationAudit === 1">
          ☐否☑是
        </template>
        <template v-else-if="bidBaseInfo.hasQualificationAudit === 0">
          ☑否☐是
        </template>
        <template v-else> ☐否☐是 </template>
        <div>3、 完成租赁活动</div>
        <div>
          竞价完成后，租赁平台向租赁各方发送结果通知，并在收讫服务费后出具租赁凭证。
        </div>
        <div>出租方与承租方应按照本项目公告内容及招租结果签订租赁合同。</div>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions bordered :column="1" class="desc-block">
      <template slot="title">
        <div class="desc-title">服务费付款主体</div>
      </template>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">服务费付款主体</span>
        </template>
        <template v-if="bidBaseInfo.paymentSubject === 1">承租方</template>
        <template v-else-if="bidBaseInfo.paymentSubject === 2">出租方</template>
        <template v-else-if="bidBaseInfo.paymentSubject === 3"
          >双方各付</template
        >
        <template v-else>-</template>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions bordered :column="1" class="desc-block">
      <template slot="title">
        <div class="desc-title">服务费</div>
      </template>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">服务费</span>
        </template>
        <div>1、本项目若底价成交:服务费为首年首月租金挂牌价格*50%;</div>
        <div>
          2、本项目若高于底价成交:服务费为首年首月租金挂牌价格*50%+首年年租金增值额(首年年租金成交价格-首年年租金挂牌价格)的20%。
        </div>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions bordered :column="1" class="desc-block">
      <template slot="title">
        <div class="desc-title">保证金事项</div>
      </template>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">保证金事项</span>
        </template>
        {{ bidBaseInfo.hasPayBond }}
        <div>交纳金额：{{ bidBaseInfo.bondAmount }}元</div>
        <div>
          2.交纳时间：招租公告起始日至招租公告截止日前交纳至租赁平台指定银行账户，实际以租赁平台到账时间为准。意向承租方逾期未交纳保证金的，视为放弃意向承租资格。
        </div>
        <div>3.交纳方式：线上交纳 保证金收款银行及账号</div>
        <div>4.返还方式：</div>
        <div>
          （1）意向承租方被确定为承租方且不存在违规违约情形的，其交纳的保证金在租赁平台出具租赁凭证后全额返还；
        </div>
        <div>
          （2）意向承租方未被确定为承租方，且未出现《上海交易集团有限公司不动产租赁平台保证金操作指引》所列责任赔偿情形的，应在承租方被确定后3个工作日内将其已交纳的保证金返还；
        </div>
        <div>
          （3）意向承租方已交纳保证金，未被出租方确认承租资格的，租赁平台在收到出租方书面意见之日起3个工作日内，将意向承租方交纳的保证金返还；
        </div>
        <div>
          （4）租赁平台应当在作出招租中止或终结决定之日起3个工作日内，将不涉及公开招租活动中止或终结事项的意向承租方交纳的保证金返还；
        </div>
        <div>
          （5）出租底价以价格区间方式公示的，意向承租方在查看出租底价后放弃承租的，租赁平台在收到意向承租方退出申请之日起3个工作日内，将其已交纳的保证金返还。
        </div>
        <div>
          5.为保护租赁各方合法利益，出租方在此做出特别提示，意向承租方一旦提交有效材料经租赁平台确认，且已经交纳保证金的，即获得竞价或择优遴选资格，意向承租方需遵守租赁平台关于保证金的相关规则，其对如下内容作出承诺：如意向承租方存在以下任何一种情形，出租方可依法依规向意向方主张相应的赔偿责任，租赁平台将按照保证金相关规则处理。
        </div>
        <div>
          （1）意向承租方提供虚假、失实、无效或不完整材料造成出租方损失的；
        </div>
        <div>（2）意向承租方利用获取的商业秘密，侵害出租方合法权益的；</div>
        <div>
          （3）意向承租方之间相互串通，影响公平竞争，侵害出租方合法权益的；
        </div>
        <div>（4）意向承租方违反法律法规或相关规定给出租方造成损失的。</div>
      </a-descriptions-item>
    </a-descriptions>
  </section>
</template>

<script>
export default {
  props: {
    bidBaseInfo: {
      type: Object,
      default: () => null,
    },
    houseBaseInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      intentionLeaseRangeList: [
        { value: 1, note: "依法设立并有效存续的企业法人" },
        { value: 2, note: "具备完全民事行为能力的自然人" },
        { value: 4, note: "个体工商户" },
        { value: 8, note: "其他经济组织" },
        { value: 16, note: "依法设立并有效存续的境内企业法人或其分支机构" },
        { value: 16384, note: "其他" },
      ],
    };
  },
  methods: {
    getIntentionLeaseRangeText() {
      let values = this.bidBaseInfo.intentionLeaseRange;

      if (!values) return "";

      // 兼容后端返回 '["1","2"]' 这种字符串
      if (typeof values === "string") {
        try {
          values = JSON.parse(values);
        } catch (e) {
          values = [];
        }
      }

      values = values.map((item) => Number(item));

      const textList = this.intentionLeaseRangeList
        .filter((item) => values.includes(item.value))
        .map((item) => {
          if (
            item.value === 16384 &&
            this.bidBaseInfo.intentionLeaseRangeDesc
          ) {
            return `其他：${this.bidBaseInfo.intentionLeaseRangeDesc}`;
          }
          return item.note;
        });

      return textList.join("；");
    },
  },
};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.desc-label-text {
  font-weight: 500;
}

.fixed-13-desc /deep/ .ant-descriptions-item-label {
  width: 25%;
}

.fixed-13-desc /deep/ .ant-descriptions-item-content {
  width: 75%;
}

.desc-title {
  text-align: center;
  background: #fafafa;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #e8e8e8;
  border-bottom: none;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
}

.desc-block /deep/ .ant-descriptions-item-content {
  width: 75%;
  background: white;
}

.bid-mode-template {
  line-height: 28px;
  font-size: 14px;
}

.bid-mode-row {
  display: grid;
  grid-template-columns: 100px 1fr;
  align-items: center;
}

.bid-mode-row span {
  white-space: nowrap;
}
</style>